import { useMemo } from "react";
import BrandSelectionStrategy from "../presentationSelection/wizardStrategies/Brand";
import DrugSelectionStrategy from "../presentationSelection/wizardStrategies/Drug";
import _ from "lodash";
import { useHealthCenterRules } from "../../../../../../../utils/hooks";

const BRAND_STRATEGY = "brand";
const DRUG_STRATEGY = "drug";

const useVademecumStrategy = () => {
  const healthCenterMedicinesRules = useHealthCenterRules("medicalDocuments.prescription.medicines");
  const strategy = healthCenterMedicinesRules?.strategy || BRAND_STRATEGY;

  const strategies = useMemo(() => ({
    [BRAND_STRATEGY]: {
      PresentationSelection: {
        WizardComponent: BrandSelectionStrategy
      },
      ListConfig: {
        showBrandColumn: true,
        vademecumMapper: _.identity
      }
    },
    [DRUG_STRATEGY]: {
      PresentationSelection: {
        WizardComponent: DrugSelectionStrategy,
        genericOnlyDefault: false
      },
      ListConfig: {
        showBrandColumn: false,
        vademecumMapper: (vademecum) => 
          _(vademecum)
            .map(medicine => medicine.principioActivo === "accesorio" ? _.assign({}, medicine, { principioActivo: medicine.marcaComercial }) : medicine)
            .uniqBy("principioActivo")
            .value()
      }
    }
  }), []);

  return strategies[strategy];
};

export default useVademecumStrategy;